import React from 'react';
import { Box } from '@mui/material';
import { useFilterContext } from 'framework/list';
import { Button } from 'framework/ui/mui-builder';

interface FilterActionsProps {
  onChangeCallback: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const PersonTimelineFilterActions = ({ onChangeCallback }: FilterActionsProps) => {
  const { apply } = useFilterContext();

  return (
    <Box className="dropdown_btn_box">
      <Button
        onClick={(event: any) => {
          onChangeCallback(event);
          apply();
        }}
      >
        Apply
      </Button>
    </Box>
  );
};

export default PersonTimelineFilterActions;
